import { Button } from "@/components/ui/button";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { MoreHorizontal } from "lucide-react";

// A subtle labeled divider for grouping actions inside the ⋯ More menu
// (e.g. everyday actions vs. "Warehouse actions"). Render conditionally so an
// empty group never leaves a dangling label.
export function MoreSection({ label }) {
  return (
    <div className="px-1 pt-2.5 pb-1 mt-1.5 border-t border-slate-100 first:border-t-0 first:mt-0 first:pt-0.5">
      <span className="text-[10px] font-bold uppercase tracking-[0.08em] text-slate-400">{label}</span>
    </div>
  );
}

// "Primary + ⋯ More" action grouping. Secondary actions live inside a tidy, viewport-aware
// dropdown (Radix Popover) so a busy header reads as one primary action by default and the
// menu never overflows off-screen. Self-contained dialog/upload/select action components
// keep their own working triggers — the menu just closes when one is tapped.
export function MoreActions({ children, testid = "more-actions", label = "More" }) {
  const items = Array.isArray(children) ? children.filter(Boolean) : (children ? [children] : []);
  if (items.length === 0) return null;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button data-testid={testid} variant="ghost" size="sm" className="rounded-lg h-9 text-slate-600 hover:text-slate-900">
          <MoreHorizontal className="w-4 h-4 mr-1.5" />{label}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        sideOffset={8}
        collisionPadding={12}
        data-testid={`${testid}-menu`}
        className="w-64 max-h-[70dvh] overflow-y-auto p-2 rounded-xl border-slate-200 shadow-lg flex flex-col gap-1.5 [&_button]:w-full [&_button]:justify-start"
      >
        {items}
      </PopoverContent>
    </Popover>
  );
}
